module.exports = __webpack_public_path__ + "img/icon1.575e8383.png";